module.exports = __webpack_public_path__ + "static/media/close-white.a804185b.png";